module.exports = __webpack_public_path__ + "img/spider-web.9c99cb33.svg";